import {
  FormPagePropertyItemSelectionRegistrationLimitDeadlineExceededLabelDisplayType,
  FormPagePropertyItemSelectionRegistrationLimitLabelDisplaySetting,
  FormPagePropertyItemSelectionRegistrationLimitRemainingLabelDisplayType,
  FormPagePropertyItemSelectionRegistrationLimitUpperLimitReachedLabelDisplayType,
} from 'backend';
import { RegistrationLimitHideOption } from 'shared';

const hideRemain = (
  displayType:
    | FormPagePropertyItemSelectionRegistrationLimitRemainingLabelDisplayType
    | undefined,
): boolean => {
  return (
    displayType ===
    FormPagePropertyItemSelectionRegistrationLimitRemainingLabelDisplayType.Hidden
  );
};

const hideUpperLimitReachedOption = (
  displayType:
    | FormPagePropertyItemSelectionRegistrationLimitUpperLimitReachedLabelDisplayType
    | undefined,
): boolean => {
  return (
    displayType ===
    FormPagePropertyItemSelectionRegistrationLimitUpperLimitReachedLabelDisplayType.Hidden
  );
};

const hideDeadlineExceededOption = (
  displayType:
    | FormPagePropertyItemSelectionRegistrationLimitDeadlineExceededLabelDisplayType
    | undefined,
): boolean => {
  return (
    displayType ===
    FormPagePropertyItemSelectionRegistrationLimitDeadlineExceededLabelDisplayType.Hidden
  );
};

export const getRegistrationLimitHideOption = (
  labelDisplay:
    | FormPagePropertyItemSelectionRegistrationLimitLabelDisplaySetting
    | undefined,
): RegistrationLimitHideOption => {
  return {
    hideRemain: hideRemain(labelDisplay?.remaining.displayType),
    hideUpperLimitReachedOption: hideUpperLimitReachedOption(
      labelDisplay?.upperLimitReached.displayType,
    ),
    hideDeadlineExceededOption: hideDeadlineExceededOption(
      labelDisplay?.deadlineExceeded.displayType,
    ),
  };
};
